module.exports = __webpack_public_path__ + "img/contest-2026.3e11f63d.png";